import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { CallbackComponent } from 'redux-oidc';
import { replace } from 'react-router-redux';

import userManager from '../../utils/userManager';

const Wrapper = styled.div`
  text-align: center;
  margin-top: 50px;
  font-size: 16px;
  color: ${props => props.theme.primary};
`;

const Callback = ({ t, dispatch }) => (
  <CallbackComponent
    userManager={userManager}
    successCallback={user => {
      dispatch(replace(user.state.redirectUrl));
    }}
    errorCallback={error => {
      dispatch(replace('/login'));
    }}
  >
    <Wrapper>{t('messages.redirecting')}</Wrapper>
  </CallbackComponent>
);

export default connect()(translate()(Callback));
